/*
 * ct-tambien-desc — precio por metro y descuento del rollo en el título de "También disponible". CT 2026-09-28.
 * Pedido de Camilo: en la ficha x Metros, la tarjeta del x Rollo dice "8001 x Rollo · 23% off · $4.200 mt".
 *
 *   precio por unidad del rollo = ceil(precio de la variante elegida ÷ su metraje)   (igual que product-price.js)
 *   descuento = (precio de la variante de metros elegida en la ficha − precio por unidad) ÷ precio de metros, ENTERO hacia abajo
 *
 * · Si el rollo no sale más barato por unidad: solo "$X mt".
 * · Tarjeta que no es rollo (la de metros en una ficha x Rollo) o ficha x Rollo: solo "$X mt".
 * · Unidades distintas (rollo en kilos, ficha por metro): solo "$X kg", sin descuento.
 * · Unidad: "kg" si la opción de cantidad del producto de la tarjeta es Kilos (o el título dice x Kilo); si no, "mt".
 * · Se recalcula al elegir otro rollo en la tarjeta (el input oculto dispara 'change', ct-rollo-select.js) y al cambiar
 *   la variante de la ficha (cualquier 'change' del formulario de la ficha).
 * Usa window.CTPrecio (product-price.js): toNumberFlexible, formatCOPFromCents y getVariantId, las mismas funciones
 * de la línea "$1.350.000 los 100 mts a $13.500 mt".
 */
(function () {
  function precios(blk) {
    if (blk._ctPrecios) return blk._ctPrecios;
    const s = blk.querySelector('[data-ct-ficha-precios]');
    try { blk._ctPrecios = s ? JSON.parse(s.textContent) : {}; } catch (e) { blk._ctPrecios = {}; }
    return blk._ctPrecios;
  }

  function texto(li, blk) {
    const P = window.CTPrecio;
    const inp = li.querySelector('.complementary-variant-id');
    if (!P || !inp) return '';
    const precio = Number(inp.dataset.price);
    const cant = P.toNumberFlexible(inp.dataset.cant) || 1;
    if (!Number.isFinite(precio) || precio <= 0) return '';
    const porUnidad = Math.ceil(precio / cant);
    const unidad = li.dataset.ctUnidad === 'kg' ? 'kg' : 'mt';
    const pu = `${P.formatCOPFromCents(porUnidad)} ${unidad}`;
    const esRollo = li.dataset.ctEsRollo === 'true';
    const fichaRollo = blk.dataset.ctFichaRollo === 'true';
    // solo se compara en la MISMA unidad: un rollo en kilos contra una ficha por metro no tiene descuento que mostrar
    const mismaUnidad = (blk.dataset.ctFichaUnidad === 'kg' ? 'kg' : 'mt') === unidad;
    if (esRollo && !fichaRollo && mismaUnidad) {
      // variante de metros elegida en la ficha; sin formulario (bajo pedido) se toma la primera de la ficha
      const mapa = precios(blk);
      const id = P.getVariantId();
      const ref = Number(id && mapa[String(id)] != null ? mapa[String(id)] : mapa[Object.keys(mapa)[0]]);
      if (Number.isFinite(ref) && ref > 0 && porUnidad < ref) {
        // CT 2026-09-28 (Camilo): ENTERO redondeado hacia ABAJO (23.99% -> "23% off"). En centavos enteros: (ref-pu)*100
        // y ref son enteros, así un 30% exacto no cae a 29 por la coma flotante. Si da 0, no hay "off".
        const pct = Math.floor(((ref - porUnidad) * 100) / ref);
        if (pct >= 1) return { off: `${pct}% off`, pu };
      }
    }
    return { off: '', pu };
  }

  function pintar(li, blk) {
    const el = li.querySelector('[data-ct-tdesc]');
    if (!el) return;
    const t = texto(li, blk);
    if (!t || !t.pu) { if (el.textContent) el.textContent = ''; return; }
    // Se arma con nodos de texto (no innerHTML). "off" va en su propio span para destacarlo.
    const clave = `${t.off}|${t.pu}`;
    if (el.dataset.ctClave === clave) return;
    el.dataset.ctClave = clave;
    el.textContent = '';
    el.append(' · ');
    if (t.off) {
      const s = document.createElement('span');
      s.className = 'ct-tdesc__off';
      s.textContent = t.off;
      el.append(s, ' · ');
    }
    el.append(t.pu);
  }

  function todo() {
    document.querySelectorAll('.complementary-products').forEach((blk) => {
      blk.querySelectorAll('.complementary__item').forEach((li) => pintar(li, blk));
    });
  }

  function instalar() {
    todo();
    document.addEventListener('change', (e) => {
      const li = e.target.closest && e.target.closest('.complementary__item');
      if (li) { const blk = li.closest('.complementary-products'); if (blk) pintar(li, blk); }
    });
    // CT 2026-09-29 — el cambio de variante de la ficha ya no sube a document en burbuja (critical-global.js, VariantSelects):
    // se escucha en CAPTURA. El tema actualiza el input[name="id"] despues del evento: por eso la espera.
    document.addEventListener('change', (e) => {
      if (e.target.closest && e.target.closest('.complementary__item')) return;
      setTimeout(todo, 120);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', instalar);
  else instalar();
})();
